import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import PopoverList from 'components/popover-list/PopoverList';

import { __t, applyTranslations } from 'utils/language';
import {
  DELIVERABLE_TYPE_INSTAGRAM_STORY as IG_STORY_TYPE
} from 'utils/deliverables';

import './content-performance-filter.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('../../content-performance.i18n.json'));

import type { MixedSelectDropdownItem } from 'types';
import type {
  ContentPerformanceDataType
} from 'modules/reporting/components/content-performance/types';

type Props = {
  label: string,
  type: 'kpi' | 'format',
  selectedOptionKpi: string,
  selectedOptionFormat: string,
  dataTypesToShow: Array<ContentPerformanceDataType>,
  showPopover?: boolean,
  onSetSelectedOptions: (a: Array<MixedSelectDropdownItem>) => void
};

const DROPDOWN_OPTIONS = {
  kpi: ['impressions', 'likes', 'engagement_rate_followers'],
  format: ['all', 'instagram_post', 'instagram_story', 'instagram_reel', 'tiktok_video', 'youtube_video']
};

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'content_performance';

const renderPopover = (): JSX.Element => (
  <div className="content-performance-filter__popover">
    <PopoverList
      list={DROPDOWN_OPTIONS.kpi.map(option => ({
        title: __t(`${COMMON_MSG_KEY}.kpis.${option}`),
        body: __t(`${MSG_KEY}.tooltips.${option}`)
      }))}
    />
  </div>
);

const ContentPerformanceFilter = ({
  label,
  type,
  selectedOptionKpi,
  selectedOptionFormat,
  dataTypesToShow,
  showPopover,
  onSetSelectedOptions
}: Props): JSX.Element => {
  let options = DROPDOWN_OPTIONS[type] || [];

  // remove "likes" if only ig story tasks exist
  if (type === 'kpi' && dataTypesToShow.length === 1 && dataTypesToShow[0] === IG_STORY_TYPE) {
    options = options.filter(option => option !== 'likes');
  }

  // remove options that don't have tasks assigned
  if (type === 'format') {
    options = options.filter(option => (
      option === 'all' || dataTypesToShow.includes(option as ContentPerformanceDataType)
    ));
  }

  return (
    <div className="content-performance-filter">
      <div className="content-performance-filter__section">
        <div className="content-performance-filter__label">
          <div>
            {label}
          </div>
          {
            showPopover &&
              renderPopover()
          }
        </div>
        <div className="content-performance-filter__dropdown">
          <MixedSelectDropdown
            key={`content-performance-filter__dropdown__${type}`}
            name={`content-performance-filter__dropdown__${type}`}
            items={options.map(value => ({
              identifier: value,
              label: __t(`${MSG_KEY}.${type}s.${value}`),
              value,
              isSelected: (type === 'kpi' && value === selectedOptionKpi)
                || (type === 'format' && value === selectedOptionFormat),
              isDisabled: (type === 'kpi' && value === 'likes' && selectedOptionFormat === IG_STORY_TYPE)
                || (type === 'format' && value === IG_STORY_TYPE && selectedOptionKpi === 'likes')
            }))}
            onItemsToggle={onSetSelectedOptions}
            data={{ type }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContentPerformanceFilter;
